export const menuData = [
  { title: "About Us", path: "/about" },
  { title: "Contact", path: "/contact" },
  { title: "Support", path: "/support" },
]
